import React from 'react'
import { SparklesIcon } from 'components/Utils/Icons'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'

function EditorNextLabel({ isNext, isEditorNext }) {
  return (
    isNext &&
    isEditorNext && (
      <TooltipOnHover
        id="editor-next-label"
        placement="bottom"
        delayShow={0}
        tooltipContent="You are using a preview version of the editor"
      >
        <div className="position-relative">
          <div className="radius-normal padding-vertical-small flexbox flexbox-centered pointer background-red shade-100-important">
            <SparklesIcon size={12} />
          </div>
        </div>
      </TooltipOnHover>
    )
  )
}

export default React.memo(EditorNextLabel)
